import { render, staticRenderFns } from "./ErrorsForm.vue?vue&type=template&id=015547c1"
import script from "./ErrorsForm.vue?vue&type=script&lang=js"
export * from "./ErrorsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports